(function () {
    'use strict';

    angular.module("imApp").factory("travelWageService", ['$ihttp', function ($ihttp) {
        let service = {
            getTravelWage: function (parms) {
                return $ihttp.post({
                    method: 1489,
                    parameters: parms || {}
                });
            },
            listTravelWageTypes: function (parms) {
                return $ihttp.post({
                    method: 1490,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1492,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
